export const Stages = {
    production: "production",
    prodtest: "prodtest",
    qa: "qa",
    dev: "dev",
    indy: "indy"
  }
